const $ = jQuery;

export default function cancelAppointment() {
    const $appointmentContainer = $('#cancel-appointment');
    const $screen1 = $appointmentContainer.find('.cancel-appointment__screen--1');
    let postId = $appointmentContainer.data('post-id');
    let postKey = $appointmentContainer.data('post-key');

    $('.js-cancel-appointment--confirmation').on('click', function (e) {
        e.preventDefault();

        $.ajax({
            url: menaObject.ajaxurl,
            dataType: 'html',
            type: 'POST',
            data: {
                action: 'cancelAppointment',
                postId: postId,
                postKey: postKey,
            },
            beforeSend: function () {
                $screen1.addClass('loading');
            },
            success: function (data) {
                if (data) {
                    window.location.href = window.location.origin;
                    return;
                }

                $screen1.removeClass('loading');

                $screen1.removeClass('active');
                $appointmentContainer.find('.cancel-appointment__screen--2').addClass('active');
            },
            error: function (error) {
                console.log(error);
            },
        });
    });
}
